export const WeekDays = {
    data() {
        let days = moment.weekdaysMin();
        let date = moment();

        return {
            weekDays: days.map((day) => {
                date.day(day);

                return {
                    name: day,
                    number: date.isoWeekday(),
                    selected: false
                }
            }).sort((d1, d2) => d1.number - d2.number)
        }
    },

    methods: {
        initWeekDays() {
            this.weekDays.forEach((day) => day.selected = false);
            this.toggleWeekDay();
        },

        toggleWeekDay(day) {
            if (day) day.selected = !day.selected;

            // Force one week day to be selected
            if (this.weekDays.filter((day) => day.selected).length == 0) {
                for (let i = 0; i < this.weekDays.length; i++) {
                    if (this.weekDays[i].number == moment(this.start_date).isoWeekday()) {
                        this.weekDays[i].selected = true;
                    }
                }
            }
        },
    }
};
